var map = {
	"./standard/Dashboard": 462,
	"./standard/Dashboard.scss": 578,
	"./standard/Dashboard.tsx": 462,
	"./standard/Declare": 460,
	"./standard/Declare.scss": 579,
	"./standard/Declare.tsx": 460,
	"./standard/Edumain": 441,
	"./standard/Edumain.scss": 580,
	"./standard/Edumain.tsx": 441,
	"./standard/Eduresult": 458,
	"./standard/Eduresult.scss": 581,
	"./standard/Eduresult.tsx": 458,
	"./standard/Exam": 459,
	"./standard/Exam.scss": 582,
	"./standard/Exam.tsx": 459,
	"./standard/Faq": 442,
	"./standard/Faq.scss": 583,
	"./standard/Faq.tsx": 442,
	"./standard/Intro": 443,
	"./standard/Intro.scss": 584,
	"./standard/Intro.tsx": 443,
	"./standard/Login": 444,
	"./standard/Login.scss": 297,
	"./standard/Login.tsx": 444,
	"./standard/Mudlogin": 445,
	"./standard/Mudlogin.scss": 446,
	"./standard/Mudlogin.tsx": 445,
	"./standard/Mudmanage": 447,
	"./standard/Mudmanage.scss": 585,
	"./standard/Mudmanage.tsx": 447,
	"./standard/Mypage": 448,
	"./standard/Mypage.scss": 586,
	"./standard/Mypage.tsx": 448,
	"./standard/Target": 461,
	"./standard/Target.scss": 604,
	"./standard/Target.tsx": 461,
	"./standard/Template": 455,
	"./standard/Template.scss": 605,
	"./standard/Template.tsx": 455,
	"./standard/edumain/Edulogin": 606,
	"./standard/edumain/Edulogin.tsx": 606,
	"./standard/edumain/Eduplay": 652,
	"./standard/edumain/Eduplay.tsx": 652,
	"./standard/edumain/Findpassword": 610,
	"./standard/edumain/Findpassword.tsx": 610,
	"./standard/edumain/Setpassword": 611,
	"./standard/edumain/Setpassword.tsx": 611,
	"./standard/exam/Bytarget": 612,
	"./standard/exam/Bytarget.tsx": 612,
	"./standard/exam/Bytemplate": 613,
	"./standard/exam/Bytemplate.tsx": 613,
	"./standard/exam/Infectionpc": 653,
	"./standard/exam/Infectionpc.tsx": 653,
	"./standard/exam/Leakfile": 654,
	"./standard/exam/Leakfile.tsx": 654,
	"./standard/exam/Pi": 650,
	"./standard/exam/Pi.tsx": 650,
	"./standard/exam/Tag": 614,
	"./standard/exam/Tag.tsx": 614,
	"./standard/login/Active": 615,
	"./standard/login/Active.tsx": 615,
	"./standard/login/Already": 616,
	"./standard/login/Already.tsx": 616,
	"./standard/login/Basic": 617,
	"./standard/login/Basic.tsx": 617,
	"./standard/login/First": 618,
	"./standard/login/First.tsx": 618,
	"./standard/login/Otp": 619,
	"./standard/login/Otp.tsx": 619,
	"./standard/login/Pwreset": 620,
	"./standard/login/Pwreset.tsx": 620,
	"./standard/login/Register": 621,
	"./standard/login/Register.tsx": 621,
	"./standard/mudlogin/Admin": 622,
	"./standard/mudlogin/Admin.tsx": 622,
	"./standard/mudlogin/Adminfirst": 623,
	"./standard/mudlogin/Adminfirst.tsx": 623,
	"./standard/mudlogin/Pwchange": 624,
	"./standard/mudlogin/Pwchange.tsx": 624,
	"./standard/mudmanage/Api": 625,
	"./standard/mudmanage/Api.tsx": 625,
	"./standard/mudmanage/Attach": 644,
	"./standard/mudmanage/Attach.tsx": 644,
	"./standard/mudmanage/Basicconf": 626,
	"./standard/mudmanage/Basicconf.tsx": 626,
	"./standard/mudmanage/Conf.scss": 96,
	"./standard/mudmanage/Edutemplate": 352,
	"./standard/mudmanage/Edutemplate.tsx": 352,
	"./standard/mudmanage/Examing": 651,
	"./standard/mudmanage/Examing.tsx": 651,
	"./standard/mudmanage/Examtemplate": 350,
	"./standard/mudmanage/Examtemplate.tsx": 350,
	"./standard/mudmanage/License": 648,
	"./standard/mudmanage/License.tsx": 648,
	"./standard/mudmanage/Log": 649,
	"./standard/mudmanage/Log.tsx": 649,
	"./standard/mudmanage/Monit": 627,
	"./standard/mudmanage/Monit.tsx": 627,
	"./standard/mudmanage/Netdata": 628,
	"./standard/mudmanage/Netdata.tsx": 628,
	"./standard/mudmanage/Phishingpage": 351,
	"./standard/mudmanage/Phishingpage.tsx": 351,
	"./standard/mudmanage/Rabbitmq": 629,
	"./standard/mudmanage/Rabbitmq.tsx": 629,
	"./standard/mudmanage/Setting": 630,
	"./standard/mudmanage/Setting.scss": 631,
	"./standard/mudmanage/Setting.tsx": 630,
	"./standard/mudmanage/Smtpconf": 632,
	"./standard/mudmanage/Smtpconf.tsx": 632,
	"./standard/mudmanage/Syncconf": 655,
	"./standard/mudmanage/Syncconf.tsx": 655,
	"./standard/mudmanage/Target": 645,
	"./standard/mudmanage/Target.tsx": 645,
	"./standard/mudmanage/User": 646,
	"./standard/mudmanage/User.tsx": 646,
	"./standard/mypage/Declare": 633,
	"./standard/mypage/Declare.tsx": 633,
	"./standard/mypage/Edu": 634,
	"./standard/mypage/Edu.tsx": 634,
	"./standard/mypage/License": 656,
	"./standard/mypage/License.scss": 635,
	"./standard/mypage/License.tsx": 656,
	"./standard/mypage/Notification": 636,
	"./standard/mypage/Notification.tsx": 636,
	"./standard/mypage/Profile": 637,
	"./standard/mypage/Profile.scss": 638,
	"./standard/mypage/Profile.tsx": 637,
	"./standard/mypage/Share": 657,
	"./standard/mypage/Share.scss": 639,
	"./standard/mypage/Share.tsx": 657,
	"./standard/mypage/Smtp": 640,
	"./standard/mypage/Smtp.tsx": 640,
	"./standard/template/Edutemplate": 641,
	"./standard/template/Edutemplate.tsx": 641,
	"./standard/template/Examtemplate": 642,
	"./standard/template/Examtemplate.tsx": 642,
	"./standard/template/Phishingpage": 643,
	"./standard/template/Phishingpage.tsx": 643,
	"./standard/template/Quiz": 647,
	"./standard/template/Quiz.tsx": 647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1104;